import { useStore } from 'effector-react'
import * as React from 'react'
import { Params } from './types'
import { $deposits, depositListMounted, getDeposits } from './model'

export const useDepositsList = (p: Params) => {
  React.useEffect(() => {
    depositListMounted(p)
  }, [])

  const loading = useStore(getDeposits.pending)

  const deposits = useStore($deposits)
  return { deposits, loading }
}
